import { lazy } from 'react';

export const RewardResolveForm = lazy(() => import('./RewardResolveForm'));
